import React from 'react';
import PropTypes from 'prop-types';

export default function TableHeader({ setColumnOrder, columnOrder }) {
    return (
        <>
            <tr className='table-head'>
                <th className="text-center" style={{minWidth: '100px'}}>
                    No de Documentos
                </th>
                <th className="text-center" style={{minWidth: '120px'}}>
                    Fecha
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="mov_date"
                    />
                </th>
                <th className="text-center" style={{minWidth: '130px'}}>
                    Tipo
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Folio de  venta
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="folio"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Dias Vencidos
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="dias_vencidos"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Pzs
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="pieces"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    KG
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="kgs"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Total
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="total"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Merma
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="decrease"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Otros descuentos
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="discount"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Otros cargos
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="other_charges"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Compra Neta
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="net"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Pagos
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Saldo
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="balance"
                    />
                </th>
                
            </tr>
        </>
    );
}

TableHeader.propTypes = {
    setColumnOrder: PropTypes.func,
    columnOrder: PropTypes.object
};

const ArrowsOrder = ({ setColumnOrder, column, columnOrder }) => {
    
    const isArrowDownActive = (columnOrder.column === column && columnOrder.order === 'desc');
    const isArrowUpActive = (columnOrder.column === column && columnOrder.order === 'asc');

    return (
        <span className="order arrows-order">
            <span 
                onClick={() => setColumnOrder({
                    column,
                    order: 'desc'
                })}
                className={`dropdown arrows-order__asc ${ isArrowDownActive && 'active'}`}
            >
                <span className="caret"></span>
            </span>
            <span 
                onClick={() => setColumnOrder({
                    column,
                    order: 'asc'
                })}
                className={`dropup arrows-order__desc ${isArrowUpActive && 'active'}`}
            >
                <span className="caret"></span>
            </span>
        </span>
    )
}

ArrowsOrder.propTypes = {
    column: PropTypes.string,
    setColumnOrder: PropTypes.func,
    columnOrder: PropTypes.object
};